import React, { useState } from 'react';
import { BoardExtendedData } from '../../../api/ApiTypes';
import { Icon } from '../../../concepts/resources/Icon';
import { DropButton } from '../../../ui/DropButton';
import { Popover } from '../../canvas/ui/Popover';
import { Copy } from '../../dashboard/elements/LayoutElements';
import { BoardInfoView } from './BoardInfoView';

export type BoardInfoButtonProps = {
    board?: BoardExtendedData,
};

export const BoardInfoButton = React.memo(({ board }: BoardInfoButtonProps) => {
    const [open, setOpen] = useState(false);

    return <Popover
        content={<BoardInfoView board={board} />}
        placement="bottom-start"
        inner={{ direction: 'down' }}
        open={open}
        onOpenChange={setOpen}
    >
        <DropButton active={open} overflow="0" padding=".125 .5 .125 .25" onClick={() => setOpen(true)}>
            <Icon size="1.25" src="deqo://icons/dash/board" />
            <Copy flush>{board?.label}</Copy>
        </DropButton>
    </Popover>;
});
